import { HTTP_STATUS_NOT_FOUND } from '../../constants/api'

import { getAppointmentMockError } from './Appointment.mock.utils'

const APPOINTMENT_MOCK_RECORDS = new Map()

const APPOINTMENT_MOCK_REQUEST_DUE_DATES = new Map()

export function getAppointmentMockRequestDueDate({ dueDate, requestId }) {
  return APPOINTMENT_MOCK_REQUEST_DUE_DATES.has(String(requestId))
    ? APPOINTMENT_MOCK_REQUEST_DUE_DATES.get(String(requestId))
    : dueDate
}

export function getAppointmentMockRecord(id) {
  const record = APPOINTMENT_MOCK_RECORDS.get(id)

  if (!record || record.deletedAt) {
    throw getAppointmentMockError({ status: HTTP_STATUS_NOT_FOUND })
  }

  return {
    ...record,
    requestDueDate: getAppointmentMockRequestDueDate({
      dueDate: record.requestDueDate,
      requestId: record.anchor.request?.id,
    }),
  }
}

export function getAppointmentMockRecords() {
  return [...APPOINTMENT_MOCK_RECORDS.values()]
}

export function saveAppointmentMockRecord(record) {
  APPOINTMENT_MOCK_RECORDS.set(record.id, record)

  return record
}

export function saveAppointmentMockRequestDueDate(record) {
  APPOINTMENT_MOCK_REQUEST_DUE_DATES.set(
    String(record.anchor.request.id),
    record.requestDueDate
  )

  return record
}
